export const getProcessEnvInteger = (attributeName: string): number | undefined => {
  let res: number | undefined = undefined
  const attStr = process.env[attributeName]

  if (attStr) {
    const attNum = parseInt(attStr)
    if (!isNaN(attNum)) {
      res = attNum
    }
  }
  return res
}
